import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_2} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment2 = "tfExpirationExerciseAssignment2Question";

export function expirationExerciseAssignment2() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment2.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment2Controller
    };
}

export class ExpirationExerciseAssignment2Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_2;
}
